/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendLeadRequest
 */
export interface SendLeadRequest {
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    fields: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    entityName: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    lookups?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    recordKind: SendLeadRequestRecordKindEnum;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    personEntityName?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    personFields?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLeadRequest
     */
    personLookups?: string;
}


/**
 * @export
 */
export const SendLeadRequestRecordKindEnum = {
    Lead: 'LEAD',
    Bid: 'BID'
} as const;
export type SendLeadRequestRecordKindEnum = typeof SendLeadRequestRecordKindEnum[keyof typeof SendLeadRequestRecordKindEnum];


/**
 * Check if a given object implements the SendLeadRequest interface.
 */
export function instanceOfSendLeadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "guid" in value;
    isInstance = isInstance && "fields" in value;
    isInstance = isInstance && "entityName" in value;
    isInstance = isInstance && "recordKind" in value;

    return isInstance;
}

export function SendLeadRequestFromJSON(json: any): SendLeadRequest {
    return SendLeadRequestFromJSONTyped(json, false);
}

export function SendLeadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'guid': json['guid'],
        'fields': json['fields'],
        'entityName': json['entityName'],
        'lookups': !exists(json, 'lookups') ? undefined : json['lookups'],
        'recordKind': json['recordKind'],
        'personEntityName': !exists(json, 'personEntityName') ? undefined : json['personEntityName'],
        'personFields': !exists(json, 'personFields') ? undefined : json['personFields'],
        'personLookups': !exists(json, 'personLookups') ? undefined : json['personLookups'],
    };
}

export function SendLeadRequestToJSON(value?: SendLeadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'guid': value.guid,
        'fields': value.fields,
        'entityName': value.entityName,
        'lookups': value.lookups,
        'recordKind': value.recordKind,
        'personEntityName': value.personEntityName,
        'personFields': value.personFields,
        'personLookups': value.personLookups,
    };
}

